import React from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import { BrandMark } from "../BrandMark/BrandMark";
import { useUser } from "../../hooks/useUser";
import { Footer } from "../Footer/Footer";
import { AppShell } from "./AppShell";

// Shell for edge pages that live OUTSIDE the role routers (404 / 403).
// Logged-in users get the full AppShell (side rail + top bar) so they never
// fall back to the old chrome; logged-out visitors get a minimal logo bar.
export function EdgeShell({ children }: { children: React.ReactNode }) {
  const { user } = useUser();

  if (user) return <AppShell>{children}</AppShell>;

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: "var(--topbar)",
          color: "var(--text)",
          boxShadow: "var(--sh-topbar)",
        }}
      >
        <Toolbar sx={{ minHeight: 56, px: 3 }}>
          <Link to="/">
            <BrandMark height={26} />
          </Link>
        </Toolbar>
      </AppBar>
      <Box sx={{ flex: 1 }}>{children}</Box>
      <Footer />
    </Box>
  );
}
